import * as React from "react"
import { Pagination, BlogItem, BlogTemplate, Seo } from "components"
import { AfterPage } from "types/afterjs"
import { Post } from "types/blog"
import fetchBlog from "./actions"

interface MatchProps {
	page?: string
}

export interface BlogPage {
	show_statement: string
	total_items: number
	limit: number
	total_page: number
	posts: Post[]
}

const BlogPage: AfterPage<
	{ data: BlogPage; isPhoneSized: boolean },
	MatchProps
> = ({ match, data, error, isPhoneSized }) => {
	const currentPage = parseInt(match.params.page || "1", 10)

	if (error) {
		return <h1>error: {error}</h1>
	}

	return (
		<>
			<Seo
				title="وبلاگ و مرکز آموزش"
				description="مرکز آموزش و وبلاگ مرجع آنتی ویروس، آموزش نصب آنتی ویروس، مقابله با ویروس باجگیر، پیشگری از ویروسی شدن سیستم"
				path="/blog"
			/>
			<BlogTemplate isMobile={isPhoneSized}>
				<div className="d-flex flex-column justify-content-center align-items-center">
					{data.posts.map((post) => (
						<BlogItem key={post.id} className="mb-3" {...post} />
					))}
					<Pagination
						totalItems={data.total_items}
						perPage={data.limit}
						currentPage={currentPage}
						link="/blog"
					/>
				</div>
			</BlogTemplate>
		</>
	)
}

BlogPage.getInitialProps = async ({ match, isPhoneSized }) => {
	const offset = (parseInt(match.params.page || "1", 10) - 1) * 8
	try {
		const { data } = await fetchBlog(offset)
		return { data, isPhoneSized }
	} catch (error) {
		if (error.response.status === 404) return { statusCode: 404 }
		return { error }
	}
}

export default BlogPage
